import React from 'react'
import { UseFormRegister, FieldValues, Path } from 'react-hook-form'
import { TextareaInput } from '../../../../components/form/inputs/TextareaInput'

interface ListItemProps<T extends FieldValues> {
  label: string
  value: string
  isEditing: boolean
  register?: UseFormRegister<T>
  fieldName?: keyof T
  rows?: number
}

export const ListItem = <T extends FieldValues>({
  label,
  value,
  isEditing,
  register,
  fieldName,
  rows = 3,
}: ListItemProps<T>) => {
  return (
    <div className="flex">
      <p className="font-bold text-base mb-1">・</p>
      <div className="flex-1">
        {label && <p className="font-bold text-base mb-1">{label}：</p>}
        <div className={`text-sm ${label ? 'mb-3' : 'mb-2'}`}>
          {isEditing && register && fieldName ? (
            <TextareaInput
              register={register(fieldName as Path<T>)}
              rows={rows}
            />
          ) : (
            value
          )}
        </div>
      </div>
    </div>
  )
}
